module.exports = __webpack_public_path__ + "static/img/coupon_256.63557c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon_256.png
// module id = zFUI
// module chunks = 0